import { useCallback, useEffect, useRef, useState } from "react";
import { getFileDownloadUrl } from "../../api/firebase/firestoreService";
import BadgeWithIcon from "../badgeWithIcon/badgeWithIcon";

import moment from "moment";
import Zoom from "react-medium-image-zoom";
import { SpinningLoader } from "risa-oasis-ui_v2";
import ArrowRight from "../../svg/arrowRight";

export interface ImageViewerWithTextAndBadgeProps {
  imagePath?: string;
  badgeDetails?: {
    batchText: string;
    batchBgColor: string;
    batchTextColor: string;
    batchId: string;
  };
  text?: string;
  shouldShowBottomBorder?: boolean;
  updatedAt?: string;
  priroity?: number;
}

const ImageViewerWithTextAndBadge = (
  props: ImageViewerWithTextAndBadgeProps,
) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState<string>("");
  const isMountedRef = useRef(true);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    isMountedRef.current = true;

    if (props?.imagePath && props?.imagePath?.trim() !== "") {
      getImageUrl();
    } else {
      setIsLoading(false);
    }

    return () => {
      isMountedRef.current = false;
    };
  }, [props?.imagePath]);

  const getImageUrl = useCallback(async () => {
    try {
      setIsLoading(true);
      const url = await getFileDownloadUrl(props?.imagePath ?? "");
      if (isMountedRef.current) {
        setImageUrl(url);
      }
    } catch (error) {
      // Error fetching image URL
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  }, [props?.imagePath]);

  return (
    <>
      <div className="image-viewer-with-badges-modal--badges mb-1 flex items-center gap-2">
        <div className="flex items-center gap-2 text-sm font-semibold text-primaryGray-5">
          {props?.text ?? ""}
        </div>
        <ArrowRight />
        <BadgeWithIcon
          text={props?.badgeDetails?.batchText ?? ""}
          id={props?.badgeDetails?.batchId ?? ""}
          textColor={props?.badgeDetails?.batchTextColor ?? ""}
          bgColor={props?.badgeDetails?.batchBgColor ?? ""}
        />
      </div>{" "}
      {props?.updatedAt && props?.updatedAt?.trim() !== "" && (
        <div className="image-viewer-with-badges-modal--badges--updated-at mb-2 text-right text-xs font-semibold text-primaryGray-1">
          Updated at:{" "}
          {moment(props?.updatedAt ?? "").format("MM/DD/YYYY") ?? ""}
        </div>
      )}
      <div className="image-viewer-with-badges-modal--badges--image relative mb-2 border border-primaryGray-15">
        {isLoading && (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-white">
            <SpinningLoader />
          </div>
        )}
        <Zoom>
          <img
            src={imageUrl}
            alt={`RPA Screenshot`}
            onLoad={handleImageLoad}
            className="block w-full"
            style={{ opacity: isLoading ? 0 : 1 }}
          />
        </Zoom>
      </div>
      {props?.shouldShowBottomBorder && (
        <div className="image-viewer-with-badges-modal--badges--image-border mb-2 border-b-1 border-dashed border-primaryGray-14"></div>
      )}
    </>
  );
};

export default ImageViewerWithTextAndBadge;
